(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eds-drive-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var DISPLAY_FIXES = {
      'Break Transistor': 'Brake Transistor',
      'Dynamic Breaking': 'Dynamic Braking',
      'High Performace': 'High Performance',
      'Built-In DC Choke See -te-7': 'Built-In DC Choke'
    };

    var FIXES_RE = (function () {
      var keys = Object.keys(DISPLAY_FIXES).map(function (k) {
        return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      });
      return new RegExp(keys.join('|'), 'g');
    })();

    var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    var ESCAPE_RE = /[&<>"']/g;

    var STAGGER_CAP = 12;
    var DEFAULT_APP_CATEGORIES = ['General Purpose', 'Application Specific', 'High Performance'];
    var APP_CATEGORY_ALIASES = {
      'general purpose': 'General Purpose',
      'general-purpose': 'General Purpose',
      'application specific': 'Application Specific',
      'application-specific': 'Application Specific',
      'high performance': 'High Performance',
      'high-performance': 'High Performance',
      'high performace': 'High Performance'
    };

    var EMC_NO_VALUES = {
      '': 1,
      '0': 1,
      'no': 1,
      'none': 1,
      'false': 1,
      'not included': 1,
      'without emc': 1,
      'without emc filter': 1,
      'external': 1,
      'external filter': 1,
      'no filter': 1
    };

    var MOBILE_HIDDEN = {
      output_voltage: 1,
      approvals: 1,
      built_in_protection: 1,
      display_type: 1,
      special_feature: 1,
      fieldbus: 1
    };

    function escapeHTML(s) {
      return String(s).replace(ESCAPE_RE, function (ch) { return ESCAPE_MAP[ch]; });
    }

    function toText(v) {
      if (v === null || v === undefined) return '';
      if (Array.isArray(v)) {
        return v.map(toText).filter(Boolean).join(', ');
      }
      if (typeof v === 'object') {
        if (v.value !== undefined) return toText(v.value);
        if (v.name !== undefined) return toText(v.name);
        return '';
      }
      return String(v).trim();
    }

    function fixText(v) {
      var t = toText(v);
      if (!t) return '';
      if (DISPLAY_FIXES[t]) return DISPLAY_FIXES[t];
      return t.replace(FIXES_RE, function (m) { return DISPLAY_FIXES[m]; });
    }

    function normalize(v) {
      return toText(v).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function normalizeHandle(v) {
      return normalize(v).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function canonicalAppCategory(value) {
      var n = normalize(value);
      if (!n) return '';
      return APP_CATEGORY_ALIASES[n] || APP_CATEGORY_ALIASES[normalizeHandle(value)] || '';
    }

    function canonicalEMC(value) {
      var n = normalize(value);
      if (EMC_NO_VALUES[n]) return 'No';
      if (n.indexOf('without') !== -1 || n.indexOf('external') !== -1 || n.indexOf('no emc') !== -1) return 'No';
      return 'Yes';
    }

    function getAppCategoryOptions(config) {
      var raw = config && Array.isArray(config.applicationCategoryOptions)
        ? config.applicationCategoryOptions
        : DEFAULT_APP_CATEGORIES;
      var out = [];
      for (var i = 0; i < raw.length; i += 1) {
        var cat = canonicalAppCategory(raw[i]) || fixText(raw[i]);
        if (cat && out.indexOf(cat) === -1) out.push(cat);
      }
      return out.length ? out : DEFAULT_APP_CATEGORIES.slice();
    }

    function alphaCompare(a, b) {
      return String(a || '').localeCompare(String(b || ''), undefined, { numeric: true, sensitivity: 'base' });
    }

    function parseHP(v) {
      var t = toText(v);
      if (!t) return Infinity;
      var frac = t.match(/(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)/);
      if (frac) {
        var den = parseFloat(frac[2]);
        if (den) return parseFloat(frac[1]) / den;
      }
      var dec = t.match(/\d+(?:\.\d+)?/);
      return dec ? parseFloat(dec[0]) : Infinity;
    }

    function parseJSON(node) {
      if (!node) return null;
      try { return JSON.parse(node.textContent || '{}'); }
      catch (e) { return null; }
    }

    function rIC(fn) {
      if (typeof window.requestIdleCallback === 'function') {
        return window.requestIdleCallback(fn, { timeout: 1500 });
      }
      return window.setTimeout(fn, 80);
    }

    function cIC(handle) {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(handle);
      } else {
        window.clearTimeout(handle);
      }
    }
    function preprocessProduct(raw, empty) {
      var title = fixText(raw.title);
      var brand = fixText(raw.brand);
      var hp = fixText(raw.motor_power_hp);
      var amps = fixText(raw.output_current_amps);
      var iv = fixText(raw.input_voltage);
      var ov = fixText(raw.output_voltage);
      var enc = fixText(raw.enclosure_rating);
      var sku = fixText(raw.sku);
      var appr = fixText(raw.approvals);
      var prot = fixText(raw.built_in_protection);
      var feat = fixText(raw.special_feature);
      var bus = fixText(raw.fieldbus);
      var disp = fixText(raw.display_type);
      var emc = canonicalEMC(raw.emc_filter);
      var imageUrl = toText(raw.image_url);
      var imageAlt = fixText(raw.image_alt) || title || sku || 'Drive';
      var price = fixText(raw.price);
      var comparePrice = fixText(raw.compare_at_price);

      var indList = [];
      function pushAppCategory(value) {
        var cat = canonicalAppCategory(value);
        if (cat && indList.indexOf(cat) === -1) indList.push(cat);
      }
      if (Array.isArray(raw.industry)) {
        for (var ii = 0; ii < raw.industry.length; ii += 1) pushAppCategory(raw.industry[ii]);
      } else {
        pushAppCategory(raw.industry);
      }

      return {
        raw: raw,
        key: toText(raw.id) || toText(raw.handle) || sku,
        url: toText(raw.url),
        imageUrl: imageUrl,
        imageAlt: imageAlt,
        priceRaw: price,
        comparePriceRaw: comparePrice,
        titleRaw: title,
        titleEsc: escapeHTML(title || sku || 'Drive'),
        brandRaw: brand,
        skuRaw: sku,
        variantId: raw.variant_id ? String(raw.variant_id) : '',
        available: raw.available !== false,
        ariaEsc: escapeHTML(sku || toText(raw.title) || 'drive'),
        hpNum: parseHP(hp),
        text: {
          brand: brand,
          motor_power_hp: hp,
          output_current_amps: amps,
          input_voltage: iv,
          output_voltage: ov,
          enclosure_rating: enc,
          model_number: sku
        },
        display: {
          brand: escapeHTML(brand || empty),
          motor_power_hp: escapeHTML(hp || empty),
          output_current_amps: escapeHTML(amps || empty),
          input_voltage: escapeHTML(iv || empty),
          output_voltage: escapeHTML(ov || empty),
          enclosure_rating: escapeHTML(enc || empty),
          model_number: escapeHTML(sku || empty),
          approvals: escapeHTML(appr || empty),
          built_in_protection: escapeHTML(prot || empty),
          special_feature: escapeHTML(feat || empty),
          display_type: escapeHTML(disp || empty),
          fieldbus: escapeHTML(bus || empty)
        },
        original: {
          motor_power_hp: hp,
          input_voltage: iv,
          enclosure_rating: enc,
          emc_filter: emc,
          industry: indList
        },
        filter: {
          motor_power_hp: normalize(hp),
          input_voltage: normalize(iv),
          enclosure_rating: normalize(enc),
          emc_filter: normalize(emc),
          industry: indList.map(function (v) { return normalize(v); })
        }
      };
    }
    function cell(field, content, labels) {
      var hidden = MOBILE_HIDDEN[field] ? ' data-mobile-hidden="true"' : '';
      return '<td data-field="' + field + '" data-label="' + escapeHTML(labels[field] || field) + '"' + hidden + '>' + content + '</td>';
    }

    function labeledValue(field, labels, valueHTML) {
      return '<span class="eds-drive__cell-label" aria-hidden="true">' +
        escapeHTML(labels[field] || field) + '</span>' +
        '<span class="eds-drive__cell-value">' + valueHTML + '</span>';
    }

    function buildRowCellsHTML(p, icons, labels, options, brandColor) {
      var d = p.display;
      var aria = p.ariaEsc;

      var brandInner;
      if (options.brandStyle === 'chip' && p.brandRaw) {
        var chipStyle = brandColor ? ' style="--eds-drive-brand-color: ' + escapeHTML(brandColor) + '"' : '';
        brandInner = '<span class="eds-drive__chip"' + chipStyle + '>' + d.brand + '</span>';
      } else {
        brandInner = '<span class="eds-drive__brand">' + d.brand + '</span>';
      }
      var brandCell = '<td data-field="brand" data-label="' + escapeHTML(labels.brand || 'Brand') + '">' + brandInner + '</td>';

      var modelLabel = escapeHTML(labels.model_number || 'Model Number');
      var modelInner;
      if (p.url && p.skuRaw) {
        modelInner =
          '<span class="eds-drive__model-label">' + modelLabel + '</span>' +
          '<a class="eds-drive__model-link" href="' + escapeHTML(p.url) + '">' + escapeHTML(p.skuRaw) + '</a>';
      } else {
        modelInner =
          '<span class="eds-drive__model-label">' + modelLabel + '</span>' +
          '<span class="eds-drive__model">' + d.model_number + '</span>';
      }
      var modelCell = '<td data-field="model_number" data-label="' + modelLabel + '">' + modelInner + '</td>';

      var cartCell = '';
      if (options.showCart) {
        var quickLabel = options.quickViewLabel || 'Quick View';
        var cartInner =
          '<button type="button" class="eds-drive__action eds-drive__action--quick-view"' +
          ' data-quick-view data-product-key="' + escapeHTML(p.key) + '"' +
          ' aria-label="Quick view ' + aria + '">' +
          '<span class="eds-drive__action-label">' + escapeHTML(quickLabel) + '</span>' +
          '</button>';

        cartCell =
          '<td data-field="cart" data-label="' + escapeHTML(labels.cart || 'Quick View') +
          '" data-align="center"><div class="eds-drive__actions">' + cartInner + '</div></td>';
      }

      var mobileToggleCell =
        '<td class="eds-drive__mobile-toggle-cell" data-field="mobile_toggle" data-label="Details">' +
          '<button type="button" class="eds-drive__mobile-toggle" data-mobile-toggle aria-expanded="false">' +
            '<span data-mobile-toggle-text></span>' +
            '<span class="eds-drive__mobile-toggle-icon" aria-hidden="true"></span>' +
          '</button>' +
        '</td>';

      return (
        brandCell +
        cell('motor_power_hp', labeledValue('motor_power_hp', labels, d.motor_power_hp), labels) +
        cell('output_current_amps', labeledValue('output_current_amps', labels, d.output_current_amps), labels) +
        cell('input_voltage', d.input_voltage, labels) +
        (options.showOutputVoltage ? cell('output_voltage', d.output_voltage, labels) : '') +
        cell('enclosure_rating', d.enclosure_rating, labels) +
        modelCell +
        (options.showApprovals ? cell('approvals', d.approvals, labels) : '') +
        (options.showBuiltInProtection ? cell('built_in_protection', d.built_in_protection, labels) : '') +
        (options.showDisplay ? cell('display_type', d.display_type, labels) : '') +
        (options.showSpecialFeature ? cell('special_feature', d.special_feature, labels) : '') +
        (options.showFieldbus ? cell('fieldbus', d.fieldbus, labels) : '') +
        cartCell +
        mobileToggleCell
      );
    }
    function initSection(root) {
      if (root.__edsDrive) return;

      var configNode = root.querySelector('[data-eds-drive-config]');
      var dataNode = root.querySelector('[data-eds-drive-data]');
      var tbody = root.querySelector('[data-tbody]');
      var table = root.querySelector('[data-table]');
      var resetBtn = root.querySelector('[data-reset]');
      var capEl = root.querySelector('[data-cap]');
      var qvModal = root.querySelector('[data-quick-view-modal]');
      var qvCloseEls = qvModal ? Array.prototype.slice.call(qvModal.querySelectorAll('[data-quick-view-close]')) : [];
      var qvBrand = qvModal ? qvModal.querySelector('[data-qv-brand]') : null;
      var qvTitle = qvModal ? qvModal.querySelector('[data-qv-title]') : null;
      var qvModel = qvModal ? qvModal.querySelector('[data-qv-model]') : null;
      var qvMedia = qvModal ? qvModal.querySelector('[data-qv-media]') : null;
      var qvImage = qvModal ? qvModal.querySelector('[data-qv-image]') : null;
      var qvPrice = qvModal ? qvModal.querySelector('[data-qv-price]') : null;
      var qvSpecs = qvModal ? qvModal.querySelector('[data-qv-specs]') : null;
      var qvProductLink = qvModal ? qvModal.querySelector('[data-qv-product-link]') : null;
      var qvAddBtn = qvModal ? qvModal.querySelector('[data-qv-add-to-cart]') : null;
      var lastQvFocus = null;

      if (!tbody || !table || !configNode || !dataNode) return;

      var MAX_ROWS = parseInt(root.getAttribute('data-max-rows'), 10) || 400;
      if (MAX_ROWS < 50) MAX_ROWS = 50;

      var config = parseJSON(configNode);
      var initialData = parseJSON(dataNode);
      if (!config || !initialData) return;

      var APP_CATEGORY_OPTIONS = getAppCategoryOptions(config);
      var EMPTY = config.emptyValue || '\u2013';
      var SHOW_COUNTS = config.showCounts === true;
      var PLACEHOLDER = config.placeholder || 'Any';
      var MOBILE_MORE = config.mobileMoreLabel || 'View More';
      var MOBILE_LESS = config.mobileLessLabel || 'View Less';
      var EMPTY_TITLE = config.emptyTitle || 'No drives match';
      var EMPTY_MSG = config.emptyMessage || 'Try widening your filters.';
      var LABELS = config.columnLabels || {};
      var CACHE_KEY = 'eds-drive:' + (root.dataset.sectionId || '') + ':' + (root.dataset.cacheKey || 'v51');

      var brandColorMap = Object.create(null);
      var brands = Array.isArray(config.brands) ? config.brands : [];
      for (var bi = 0; bi < brands.length; bi += 1) {
        var bdef = brands[bi];
        if (bdef && bdef.name) brandColorMap[String(bdef.name).toLowerCase()] = bdef.color || '';
      }

      function colorForBrand(name) {
        if (!name) return '';
        return brandColorMap[String(name).toLowerCase()] || '';
      }

      var SHOW_STRIPE = config.showBrandStripe === true;

      var brandOrder = [];
      for (var bo = 0; bo < brands.length; bo += 1) {
        if (brands[bo] && brands[bo].name) {
          var bnorm = normalize(brands[bo].name);
          if (bnorm && brandOrder.indexOf(bnorm) === -1) brandOrder.push(bnorm);
        }
      }
      var BALANCE_BRANDS = config.balanceBrands !== false;

      var QUICK_VIEW_LABEL = config.quickViewLabel || 'Quick View';
      var CART_LABEL = config.cartLabel || 'Add';
      var CART_ADDING = config.cartAddingLabel || 'Adding';
      var CART_ADDED = config.cartAddedLabel || 'Added';
      var CART_SOLD_OUT = config.cartSoldOutLabel || 'Sold out';
      var CART_ERROR = config.cartErrorLabel || 'Try again';
      var CART_REDIRECT = config.cartRedirect === true;

      var actionOptions = {
        brandStyle: config.brandStyle === 'chip' ? 'chip' : 'plain',
        showCart: config.showCart === true,
        quickViewLabel: QUICK_VIEW_LABEL,
        cartLabel: CART_LABEL,
        cartSoldOutLabel: CART_SOLD_OUT,
        showOutputVoltage: config.showOutputVoltage !== false,
        showApprovals: config.showApprovals !== false,
        showBuiltInProtection: config.showBuiltInProtection !== false,
        showDisplay: config.showDisplay !== false,
        showSpecialFeature: config.showSpecialFeature !== false,
        showFieldbus: config.showFieldbus !== false
      };

      var emptyColspan = 6
        + (actionOptions.showOutputVoltage ? 1 : 0)
        + (actionOptions.showApprovals ? 1 : 0)
        + (actionOptions.showBuiltInProtection ? 1 : 0)
        + (actionOptions.showDisplay ? 1 : 0)
        + (actionOptions.showSpecialFeature ? 1 : 0)
        + (actionOptions.showFieldbus ? 1 : 0)
        + (actionOptions.showCart ? 1 : 0);

      var filterSelects = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var visibleFilters = filterSelects.map(function (s) { return s.dataset.filter; });
      var FILTER_KEYS = visibleFilters.slice();

      var URL_PARAMS = {
        motor_power_hp: 'hp',
        input_voltage: 'iv',
        enclosure_rating: 'enc',
        emc_filter: 'emc',
        industry: 'ind'
      };

      var state = {};
      var stateNorm = {};
      FILTER_KEYS.forEach(function (k) { state[k] = ''; stateNorm[k] = ''; });

      var desiredFilters = null;
      var products = [];
      var totalPages = (initialData.pagination && initialData.pagination.pages) ? Number(initialData.pagination.pages) : 1;
      var currentPage = (initialData.pagination && initialData.pagination.current_page) ? Number(initialData.pagination.current_page) : 1;
      var uniqueCache = Object.create(null);
      var icons = {
        cart: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.2a1.5 1.5 0 0 0 1.5-1.2L21.5 8H6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<circle cx="10" cy="20.5" r="1.4" fill="currentColor"/>' +
          '<circle cx="18" cy="20.5" r="1.4" fill="currentColor"/></svg>',
        eye: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M2.5 12s3.4-6 9.5-6 9.5 6 9.5 6-3.4 6-9.5 6-9.5-6-9.5-6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>'
      };

      var cleanup = [];
      var abortController = null;
      var idleHandle = null;
      var observer = null;
      var preloadStarted = false;
      var preloadComplete = false;

      var renderToken = 0;
      var FIRST_PAINT = 40;
      var PAINT_CHUNK = 90;
      var rafHandle = null;
      var PAYLOAD_V = 56;

      function loadFromCache() {
        try {
          var stored = sessionStorage.getItem(CACHE_KEY);
          if (!stored) return false;
          var parsed = JSON.parse(stored);
          if (!parsed || parsed.v !== PAYLOAD_V || !Array.isArray(parsed.raw)) return false;
          if (parsed.raw.length < (initialData.products || []).length) return false;
          if (actionOptions.showCart && parsed.raw.length && !('variant_id' in parsed.raw[0])) return false;
          if (actionOptions.showCart && parsed.raw.length && !('price' in parsed.raw[0])) return false;
          ingest(parsed.raw);
          preloadComplete = true;
          return true;
        } catch (e) { return false; }
      }

      function saveToCache() {
        try {
          var raw = products.map(function (p) { return p.raw; });
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ v: PAYLOAD_V, raw: raw }));
        } catch (e) {}
      }

      function ingest(rawList) {
        var seen = Object.create(null);
        var out = [];
        for (var i = 0; i < rawList.length; i += 1) {
          var raw = rawList[i];
          var k = toText(raw.id) || toText(raw.handle) || toText(raw.sku);
          if (!k || seen[k]) continue;
          seen[k] = true;
          out.push(preprocessProduct(raw, EMPTY));
        }
        products = out;
        uniqueCache = Object.create(null);
      }

      function mergeRaw(more) {
        if (!more || !more.length) return;
        var byKey = Object.create(null);
        for (var i = 0; i < products.length; i += 1) byKey[products[i].key] = true;
        var fresh = [];
        for (var j = 0; j < more.length; j += 1) {
          var raw = more[j];
          var k = toText(raw.id) || toText(raw.handle) || toText(raw.sku);
          if (!k || byKey[k]) continue;
          byKey[k] = true;
          fresh.push(preprocessProduct(raw, EMPTY));
        }
        if (fresh.length) {
          products = products.concat(fresh);
          uniqueCache = Object.create(null);
        }
      }
      function matches(p) {
        var pf = p.filter;
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          var key = FILTER_KEYS[i];
          var want = stateNorm[key];
          if (!want) continue;
          var pv = pf[key];
          if (Array.isArray(pv)) {
            if (pv.indexOf(want) === -1) return false;
          } else if (pv !== want) {
            return false;
          }
        }
        return true;
      }

      function uniqueValues(filterKey) {
        var sigParts = [];
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          sigParts.push(FILTER_KEYS[i] === filterKey ? '' : stateNorm[FILTER_KEYS[i]]);
        }
        var sig = filterKey + '|' + sigParts.join('|');
        if (uniqueCache[sig]) return uniqueCache[sig];

        var counts = Object.create(null);
        var hasEmpty = false;
        for (var j = 0; j < products.length; j += 1) {
          var p = products[j];
          var ok = true;
          for (var x = 0; x < FILTER_KEYS.length; x += 1) {
            var k = FILTER_KEYS[x];
            if (k === filterKey) continue;
            var want = stateNorm[k];
            if (!want) continue;
            var ov = p.filter[k];
            if (Array.isArray(ov)) {
              if (ov.indexOf(want) === -1) { ok = false; break; }
            } else if (ov !== want) {
              ok = false; break;
            }
          }
          if (!ok) continue;
          var val = p.original[filterKey];
          if (Array.isArray(val)) {
            if (!val.length) { hasEmpty = true; }
            else {
              for (var vi = 0; vi < val.length; vi += 1) {
                counts[val[vi]] = (counts[val[vi]] || 0) + 1;
              }
            }
          } else if (!val) {
            hasEmpty = true;
          } else {
            counts[val] = (counts[val] || 0) + 1;
          }
        }
        if (filterKey === 'industry') {
          var fixedCounts = Object.create(null);
          for (var ci = 0; ci < APP_CATEGORY_OPTIONS.length; ci += 1) {
            var cat = APP_CATEGORY_OPTIONS[ci];
            fixedCounts[cat] = counts[cat] || 0;
          }
          counts = fixedCounts;
          hasEmpty = false;
        }

        if (filterKey === 'emc_filter') {
          counts = { Yes: counts.Yes || 0, No: counts.No || 0 };
          hasEmpty = false;
        }

        var result = { counts: counts, hasEmpty: hasEmpty };
        uniqueCache[sig] = result;
        return result;
      }

      function canonOption(counts, value) {
        if (!value) return '';
        if (counts[value]) return value;
        var want = normalize(value);
        for (var k in counts) {
          if (normalize(k) === want) return k;
        }
        return '';
      }
      function repopulateSelect(filterKey, userDriven) {
        var select = root.querySelector('[data-filter="' + filterKey + '"]');
        if (!select) return;

        var info = uniqueValues(filterKey);
        var counts = info.counts;
        var keys = filterKey === 'industry'
          ? APP_CATEGORY_OPTIONS.slice()
          : (filterKey === 'emc_filter' ? ['Yes', 'No'] : Object.keys(counts).sort(alphaCompare));
        var current = state[filterKey];

        if (current) {
          var canon = canonOption(counts, current);
          if (canon) {
            if (canon !== current) {
              current = canon;
              state[filterKey] = canon;
              stateNorm[filterKey] = normalize(canon);
            }
          } else {
            current = '';
            state[filterKey] = '';
            stateNorm[filterKey] = '';
          }
        }

        if (userDriven && filterKey !== 'industry' && filterKey !== 'emc_filter' && !current && keys.length === 1 && !info.hasEmpty) {
          current = keys[0];
          state[filterKey] = current;
          stateNorm[filterKey] = normalize(current);
        }

        var html = '<option value="">' + escapeHTML(PLACEHOLDER) + '</option>';
        for (var i = 0; i < keys.length; i += 1) {
          var key = keys[i];
          var label = fixText(key) || EMPTY;
          var selected = key === current ? ' selected' : '';
          var text = SHOW_COUNTS ? label + ' (' + counts[key] + ')' : label;
          html += '<option value="' + escapeHTML(key) + '"' + selected + '>' + escapeHTML(text) + '</option>';
        }

        select.innerHTML = html;
        select.value = current;
        select.disabled = !keys.length && !current;
        syncFilterActive(filterKey);
      }

      function repopulateSelects(userDriven) {
        for (var i = 0; i < visibleFilters.length; i += 1) repopulateSelect(visibleFilters[i], userDriven);
      }

      function syncFilterActive(filterKey) {
        var wrap = root.querySelector('[data-filter-wrap="' + filterKey + '"]');
        if (!wrap) return;
        wrap.classList.toggle('is-active', Boolean(state[filterKey]));
      }

      function syncReset() {
        if (!resetBtn) return;
        var has = false;
        for (var i = 0; i < visibleFilters.length; i += 1) {
          if (state[visibleFilters[i]]) { has = true; break; }
        }
        resetBtn.disabled = !has;
      }
      function readStateFromUrl() {
        if (!window.URLSearchParams) return null;
        var params = new URLSearchParams(window.location.search);
        var found = false;
        var filters = {};
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          var fk = FILTER_KEYS[i];
          var pn = URL_PARAMS[fk];
          if (pn && params.has(pn)) {
            var v = params.get(pn);
            if (v) { filters[fk] = v; found = true; }
          }
        }
        return { found: found, filters: filters };
      }

      function applyState(restored) {
        if (!restored) return;
        var fk;
        for (fk in restored.filters) {
          if (!Object.prototype.hasOwnProperty.call(restored.filters, fk)) continue;
          if (FILTER_KEYS.indexOf(fk) === -1) continue;
          state[fk] = fk === 'emc_filter' ? canonicalEMC(restored.filters[fk]) : restored.filters[fk];
          stateNorm[fk] = normalize(state[fk]);
        }
      }

      function reassertDesired() {
        if (!desiredFilters) return;
        var fk;
        for (fk in desiredFilters) {
          if (!Object.prototype.hasOwnProperty.call(desiredFilters, fk)) continue;
          if (FILTER_KEYS.indexOf(fk) === -1) continue;
          if (state[fk]) continue;
          var info = uniqueValues(fk);
          var canon = canonOption(info.counts, desiredFilters[fk]);
          if (canon) {
            state[fk] = canon;
            stateNorm[fk] = normalize(canon);
          }
        }
      }

      function syncUrl() {
        if (!window.URLSearchParams || !window.history || !window.history.replaceState) return;
        var url = new URL(window.location.href);
        var params = url.searchParams;
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          var fk = FILTER_KEYS[i];
          var pn = URL_PARAMS[fk];
          if (!pn) continue;
          if (state[fk]) params.set(pn, state[fk]); else params.delete(pn);
        }
        params.delete('section_id');
        var qs = params.toString();
        var newUrl = url.pathname + (qs ? '?' + qs : '') + url.hash;
        try { window.history.replaceState(window.history.state, '', newUrl); } catch (e) {}
      }
      function brandRank(p) {
        var n = normalize(p.brandRaw);
        var idx = brandOrder.indexOf(n);
        return idx === -1 ? brandOrder.length : idx;
      }

      function rotateBrands(rows) {
        if (rows.length < 2) return rows.slice();
        var buckets = Object.create(null);
        var order = [];
        for (var i = 0; i < rows.length; i += 1) {
          var n = normalize(rows[i].brandRaw);
          if (!(n in buckets)) buckets[n] = [];
          buckets[n].push(rows[i]);
        }
        for (var b = 0; b < brandOrder.length; b += 1) {
          if ((brandOrder[b] in buckets) && order.indexOf(brandOrder[b]) === -1) order.push(brandOrder[b]);
        }
        for (var r = 0; r < rows.length; r += 1) {
          var nn = normalize(rows[r].brandRaw);
          if (order.indexOf(nn) === -1) order.push(nn);
        }
        var out = [];
        var ptr = Object.create(null);
        for (var o = 0; o < order.length; o += 1) ptr[order[o]] = 0;
        var remaining = rows.length;
        while (remaining > 0) {
          var advanced = false;
          for (var k = 0; k < order.length; k += 1) {
            var key = order[k];
            var arr = buckets[key];
            if (ptr[key] < arr.length) {
              out.push(arr[ptr[key]]);
              ptr[key] += 1;
              remaining -= 1;
              advanced = true;
            }
          }
          if (!advanced) break;
        }
        return out;
      }

      function groupByPower(rows) {
        if (rows.length < 2) return rows.slice();
        var groups = [];
        var groupIndex = Object.create(null);
        for (var i = 0; i < rows.length; i += 1) {
          var hp = rows[i].hpNum;
          var gk = (hp === Infinity) ? 'z' : String(hp);
          if (!(gk in groupIndex)) {
            groupIndex[gk] = groups.length;
            groups.push({ hp: hp, rows: [] });
          }
          groups[groupIndex[gk]].rows.push(rows[i]);
        }
        groups.sort(function (a, b) { return a.hp - b.hp; });
        var out = [];
        for (var g = 0; g < groups.length; g += 1) {
          var ordered = rotateBrands(groups[g].rows);
          for (var j = 0; j < ordered.length; j += 1) out.push(ordered[j]);
        }
        return out;
      }

      function sortByPowerThenBrand(rows) {
        var copy = rows.slice();
        copy.sort(function (a, b) {
          if (a.hpNum !== b.hpNum) return a.hpNum - b.hpNum;
          var br = brandRank(a) - brandRank(b);
          if (br !== 0) return br;
          return alphaCompare(a.skuRaw, b.skuRaw);
        });
        return copy;
      }

      function sortByBrandThenPower(rows) {
        var copy = rows.slice();
        copy.sort(function (a, b) {
          var br = brandRank(a) - brandRank(b);
          if (br !== 0) return br;
          if (a.hpNum !== b.hpNum) return a.hpNum - b.hpNum;
          return alphaCompare(a.skuRaw, b.skuRaw);
        });
        return copy;
      }

      function filteredRows() {
        var rows = [];
        for (var i = 0; i < products.length; i += 1) {
          if (matches(products[i])) rows.push(products[i]);
        }
        return sortByBrandThenPower(rows);
      }

      function renderResults() {
        var rows = filteredRows();
        var totalMatched = rows.length;

        var capped = false;
        if (rows.length > MAX_ROWS) {
          rows = rows.slice(0, MAX_ROWS);
          capped = true;
        }

        if (capEl) {
          if (capped) {
            capEl.textContent = 'Showing ' + MAX_ROWS + ' of ' + totalMatched + ' drives. Use the filters to narrow to specific drives.';
            capEl.hidden = false;
          } else if (totalMatched > 0) {
            capEl.hidden = true;
          }
        }

        if (!rows.length) {
          tbody.innerHTML =
            '<tr class="eds-drive__empty-row">' +
              '<td class="eds-drive__empty-cell" colspan="' + emptyColspan + '">' +
                '<div class="eds-drive__empty">' +
                  '<div class="eds-drive__empty-title">' + escapeHTML(EMPTY_TITLE) + '</div>' +
                  '<p>' + escapeHTML(EMPTY_MSG) + '</p>' +
                '</div>' +
              '</td>' +
            '</tr>';
          return;
        }

        var html = new Array(rows.length);
        for (var i = 0; i < rows.length; i += 1) {
          var p = rows[i];
          var idx = i < STAGGER_CAP ? i : STAGGER_CAP;
          var brandColor = SHOW_STRIPE || actionOptions.brandStyle === 'chip' ? colorForBrand(p.brandRaw) : '';

          if (actionOptions.brandStyle === 'chip') {
            if (p._cellsHTMLForColor !== brandColor || !p._cellsHTML) {
              p._cellsHTML = buildRowCellsHTML(p, icons, LABELS, actionOptions, brandColor);
              p._cellsHTMLForColor = brandColor;
            }
          } else if (!p._cellsHTML) {
            p._cellsHTML = buildRowCellsHTML(p, icons, LABELS, actionOptions, '');
          }

          var stripeColor = SHOW_STRIPE ? brandColor : '';
          var rowStyle = '--row-i:' + idx;
          if (stripeColor) rowStyle += ';--eds-drive-brand-color:' + stripeColor;
          var rowClass = stripeColor ? ' class="has-brand-color"' : '';

          var rowUrlAttr = p.url ? ' data-row-url="' + escapeHTML(p.url) + '"' : '';
          html[i] = '<tr' + rowClass + rowUrlAttr + ' style="' + rowStyle + '" data-mobile-row data-mobile-expanded="false">' +
            p._cellsHTML + '</tr>';
        }

        renderToken += 1;
        var token = renderToken;
        if (rafHandle) { cancelAnimationFrame(rafHandle); rafHandle = null; }

        var firstCount = Math.min(FIRST_PAINT, html.length);
        tbody.innerHTML = html.slice(0, firstCount).join('');
        labelToggles(tbody);

        if (firstCount < html.length) {
          var cursor = firstCount;
          var step = function () {
            if (token !== renderToken) return;
            var next = Math.min(cursor + PAINT_CHUNK, html.length);
            var frag = html.slice(cursor, next).join('');
            tbody.insertAdjacentHTML('beforeend', frag);
            labelToggles(tbody);
            cursor = next;
            if (cursor < html.length) {
              rafHandle = requestAnimationFrame(step);
            } else {
              rafHandle = null;
            }
          };
          rafHandle = requestAnimationFrame(step);
        }
      }

      function labelToggles(scope) {
        var toggles = scope.querySelectorAll('[data-mobile-toggle-text]:empty');
        for (var t = 0; t < toggles.length; t += 1) toggles[t].textContent = MOBILE_MORE;
      }

      function refresh(userDriven) {
        repopulateSelects(userDriven);
        renderResults();
        syncReset();
      }


      function productByKey(key) {
        for (var i = 0; i < products.length; i += 1) {
          if (String(products[i].key) === String(key)) return products[i];
        }
        return null;
      }

      function qvSpec(label, value) {
        var text = toText(value);
        if (!text || text === EMPTY) return '';
        return '<div class="eds-drive__qv-spec"><dt>' + escapeHTML(label) + '</dt><dd>' + escapeHTML(text) + '</dd></div>';
      }

      function openQuickView(key) {
        var p = productByKey(key);
        if (!p || !qvModal) return;

        lastQvFocus = document.activeElement;
        if (qvBrand) qvBrand.textContent = p.brandRaw || '';
        if (qvTitle) qvTitle.textContent = p.titleRaw || p.skuRaw || 'Drive';
        if (qvModel) qvModel.textContent = p.skuRaw ? (LABELS.model_number || 'Model Number') + ': ' + p.skuRaw : '';

        qvModal.classList.toggle('has-qv-image', Boolean(p.imageUrl));

        if (qvMedia && qvImage) {
          if (p.imageUrl) {
            qvImage.src = p.imageUrl;
            qvImage.alt = p.imageAlt || p.titleRaw || p.skuRaw || 'Drive';
            qvMedia.hidden = false;
          } else {
            qvImage.removeAttribute('src');
            qvImage.alt = '';
            qvMedia.hidden = true;
          }
        }

        if (qvPrice) {
          if (p.priceRaw) {
            qvPrice.innerHTML = '<span class="eds-drive__qv-price-current">' + escapeHTML(p.priceRaw) + '</span>' +
              (p.comparePriceRaw ? '<span class="eds-drive__qv-price-compare">' + escapeHTML(p.comparePriceRaw) + '</span>' : '');
            qvPrice.hidden = false;
          } else {
            qvPrice.innerHTML = '';
            qvPrice.hidden = true;
          }
        }

        if (qvSpecs) {
          qvSpecs.innerHTML =
            qvSpec(LABELS.motor_power_hp || 'HP', p.text.motor_power_hp) +
            qvSpec(LABELS.output_current_amps || 'Amps', p.raw.output_current_amps) +
            qvSpec(LABELS.input_voltage || 'Input Voltage', p.text.input_voltage) +
            qvSpec(LABELS.output_voltage || 'Output Voltage', p.raw.output_voltage) +
            qvSpec(LABELS.enclosure_rating || 'Enclosure', p.text.enclosure_rating) +
            qvSpec(LABELS.approvals || 'Approvals', p.raw.approvals) +
            qvSpec(LABELS.built_in_protection || 'Built-In Protection', p.raw.built_in_protection) +
            qvSpec(LABELS.display_type || 'Display', p.raw.display_type) +
            qvSpec(LABELS.special_feature || 'Special Feature', p.raw.special_feature) +
            qvSpec(LABELS.fieldbus || 'Fieldbus', p.raw.fieldbus);
        }

        if (qvProductLink) {
          qvProductLink.href = p.url || '#';
          qvProductLink.hidden = !p.url;
        }

        if (qvAddBtn) {
          qvAddBtn.setAttribute('data-variant-id', p.variantId || '');
          qvAddBtn.classList.remove('is-loading', 'is-added', 'is-error', 'is-soldout');
          qvAddBtn.removeAttribute('aria-busy');
          qvAddBtn.disabled = !(p.variantId && p.available);
          qvAddBtn.setAttribute('aria-label', p.available ? 'Add ' + p.ariaEsc + ' to cart' : CART_SOLD_OUT);
          setCartLabel(qvAddBtn, p.variantId && p.available ? CART_LABEL : CART_SOLD_OUT);
          if (!(p.variantId && p.available)) qvAddBtn.classList.add('is-soldout');
        }

        qvModal.hidden = false;
        root.classList.add('is-qv-open');
        document.documentElement.classList.add('eds-drive-qv-open');
        window.setTimeout(function () {
          var close = qvModal.querySelector('[data-quick-view-close]');
          if (close) close.focus();
        }, 0);
      }

      function closeQuickView() {
        if (!qvModal || qvModal.hidden) return;
        qvModal.hidden = true;
        root.classList.remove('is-qv-open');
        document.documentElement.classList.remove('eds-drive-qv-open');
        document.documentElement.classList.remove('eds-drive-cart-drawer-open');
        if (lastQvFocus && typeof lastQvFocus.focus === 'function') lastQvFocus.focus();
      }
      function on(el, evt, fn, opts) {
        if (!el) return;
        el.addEventListener(evt, fn, opts || false);
        cleanup.push(function () { el.removeEventListener(evt, fn, opts || false); });
      }

      function onFilterChange(e) {
        var select = e.currentTarget;
        var key = select.dataset.filter;
        state[key] = select.value || '';
        stateNorm[key] = normalize(select.value || '');
        refresh(true);
        syncUrl();
      }

      function resetFilters() {
        for (var i = 0; i < visibleFilters.length; i += 1) {
          var k = visibleFilters[i];
          state[k] = '';
          stateNorm[k] = '';
          syncFilterActive(k);
        }
        refresh(false);
        syncUrl();
      }

      function onTbodyClick(e) {
        if (!e.target.closest) return;

        var qvBtn = e.target.closest('[data-quick-view]');
        if (qvBtn) {
          e.preventDefault();
          openQuickView(qvBtn.getAttribute('data-product-key'));
          return;
        }

        var cartBtn = e.target.closest('[data-add-to-cart]');
        if (cartBtn) {
          addToCart(cartBtn);
          return;
        }

        var toggle = e.target.closest('[data-mobile-toggle]');
        if (toggle) {
          var trow = toggle.closest('[data-mobile-row]');
          if (!trow) return;
          var expanded = trow.getAttribute('data-mobile-expanded') === 'true';
          var next = !expanded;
          trow.setAttribute('data-mobile-expanded', next ? 'true' : 'false');
          trow.classList.toggle('is-mobile-expanded', next);
          toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
          var txt = toggle.querySelector('[data-mobile-toggle-text]');
          if (txt) txt.textContent = next ? MOBILE_LESS : MOBILE_MORE;
          return;
        }

        if (e.target.closest('a')) return;

        if (window.getSelection && String(window.getSelection()).length) return;

        var row = e.target.closest('[data-row-url]');
        if (row) {
          var url = row.getAttribute('data-row-url');
          if (url) window.location.href = url;
        }
      }
      function openCartDrawer(detail) {
        document.documentElement.classList.add('eds-drive-cart-drawer-open');

        var eventNames = [
          'cart:open',
          'cart-drawer:open',
          'cart:drawer:open',
          'theme:cart:open',
          'ajaxCart:open',
          'drawer:open'
        ];

        eventNames.forEach(function (name) {
          try {
            document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || { source: 'eds-drive' } }));
          } catch (err) {}
        });

        var drawerSelectors = [
          'cart-drawer',
          '#CartDrawer',
          '.cart-drawer',
          '.drawer--cart',
          '.cart-drawer-container',
          '[data-cart-drawer]',
          '[data-cart-drawer-wrapper]',
          '[data-drawer="cart"]',
          '[data-drawer-name="cart"]',
          '.mini-cart'
        ];

        var drawer = null;
        for (var i = 0; i < drawerSelectors.length; i += 1) {
          drawer = document.querySelector(drawerSelectors[i]);
          if (drawer) break;
        }

        if (drawer) {
          try {
            if (typeof drawer.open === 'function') drawer.open();
            if (typeof drawer.show === 'function') drawer.show();
          } catch (err) {}

          drawer.removeAttribute('hidden');
          drawer.setAttribute('open', '');
          drawer.setAttribute('aria-hidden', 'false');
          drawer.classList.add('is-open', 'is-active', 'active', 'open', 'animate');
        }

        if (!drawer) {
          var triggerSelectors = [
            '[data-cart-drawer-trigger]',
            '[data-action="open-cart-drawer"]',
            '[data-drawer-open="cart"]',
            '[aria-controls="CartDrawer"]',
            '[aria-controls="cart-drawer"]'
          ];

          for (var j = 0; j < triggerSelectors.length; j += 1) {
            var trigger = document.querySelector(triggerSelectors[j]);
            if (!trigger || trigger.disabled) continue;

            var rect = trigger.getBoundingClientRect();
            if (rect.width === 0 && rect.height === 0) continue;

            try {
              trigger.click();
              break;
            } catch (err) {}
          }
        }

        window.setTimeout(function () {
          document.documentElement.classList.remove('eds-drive-cart-drawer-open');
        }, 12000);
      }

      function setCartLabel(btn, text) {
        var label = btn.querySelector('[data-cart-label]');
        if (label) label.textContent = text;
      }

      function addToCart(btn) {
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || !window.fetch) return;

        if (btn.__edsResetTimer) { window.clearTimeout(btn.__edsResetTimer); btn.__edsResetTimer = null; }

        btn.setAttribute('aria-busy', 'true');
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');
        setCartLabel(btn, CART_ADDING);

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function (data) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.removeAttribute('aria-busy');
            setCartLabel(btn, CART_ADDED);

            var detail = { source: 'eds-drive', items: data && data.items ? data.items : [data], variantId: variantId };
            document.dispatchEvent(new CustomEvent('eds:cart:added', { bubbles: true, detail: detail }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
            openCartDrawer(detail);
            if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
              try { window.Shopify.onItemAdded(data); } catch (err) {}
            }

            if (CART_REDIRECT) {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
              return;
            }

            btn.__edsResetTimer = window.setTimeout(function () {
              btn.classList.remove('is-added');
              setCartLabel(btn, CART_LABEL);
            }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            btn.removeAttribute('aria-busy');
            setCartLabel(btn, CART_ERROR);
            btn.__edsResetTimer = window.setTimeout(function () {
              btn.classList.remove('is-error');
              setCartLabel(btn, CART_LABEL);
            }, 2200);
          });
      }


      if (qvCloseEls.length) {
        qvCloseEls.forEach(function (btn) {
          on(btn, 'click', function () { closeQuickView(); });
        });
      }

      if (qvAddBtn) {
        on(qvAddBtn, 'click', function () { addToCart(qvAddBtn); });
      }

      on(document, 'keydown', function (event) {
        if (event.key === 'Escape') closeQuickView();
      });
      function buildPageUrl(page) {
        var url = new URL(window.location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('page', String(page));
        return url.toString();
      }

      function fetchPage(page) {
        if (!window.fetch) return Promise.resolve(null);
        var opts = { credentials: 'same-origin' };
        if (abortController) opts.signal = abortController.signal;

        return fetch(buildPageUrl(page), opts)
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-eds-drive-data]');
            return node ? parseJSON(node) : null;
          })
          .catch(function () { return null; });
      }

      function startPreload() {
        if (preloadStarted || preloadComplete || totalPages <= 1) return;
        preloadStarted = true;

        if ('AbortController' in window) abortController = new AbortController();

        var jobs = [];
        for (var page = 1; page <= totalPages; page += 1) {
          if (page !== currentPage) jobs.push(fetchPage(page));
        }

        Promise.all(jobs).then(function (payloads) {
          var more = [];
          for (var i = 0; i < payloads.length; i += 1) {
            var pl = payloads[i];
            if (pl && Array.isArray(pl.products)) more = more.concat(pl.products);
          }
          mergeRaw(more);
          saveToCache();
          preloadComplete = true;
          reassertDesired();
          refresh(false);
        });
      }

      function schedulePreload() {
        if (preloadComplete || totalPages <= 1) return;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i += 1) {
              if (entries[i].isIntersecting) {
                if (observer) { observer.disconnect(); observer = null; }
                idleHandle = rIC(startPreload);
                break;
              }
            }
          }, { rootMargin: '400px' });
          observer.observe(root);
        } else {
          idleHandle = rIC(startPreload);
        }
      }
      function destroy() {
        if (abortController) { try { abortController.abort(); } catch (e) {} }
        if (idleHandle) cIC(idleHandle);
        if (rafHandle) { cancelAnimationFrame(rafHandle); rafHandle = null; }
        renderToken += 1;
        if (observer) { observer.disconnect(); observer = null; }
        for (var i = 0; i < cleanup.length; i += 1) {
          try { cleanup[i](); } catch (e) {}
        }
        cleanup = [];
        delete root.__edsDrive;
      }

      root.__edsDrive = { destroy: destroy };
      var restored = readStateFromUrl();
      desiredFilters = (restored && restored.found) ? restored.filters : null;

      var DEFAULT_INDUSTRY = (config.defaultIndustry || '').toString().trim();
      if (DEFAULT_INDUSTRY && FILTER_KEYS.indexOf('industry') !== -1 &&
          (!restored || !restored.filters || !restored.filters.industry)) {
        if (!restored) restored = { found: true, filters: {} };
        restored.found = true;
        restored.filters.industry = DEFAULT_INDUSTRY;
        desiredFilters = restored.filters;
      }

      var cacheHit = loadFromCache();
      if (!cacheHit) ingest(initialData.products || []);

      applyState(restored);

      for (var f = 0; f < filterSelects.length; f += 1) on(filterSelects[f], 'change', onFilterChange);
      on(resetBtn, 'click', resetFilters);
      on(tbody, 'click', onTbodyClick);

      refresh(false);

      requestAnimationFrame(function () {
        root.classList.add('is-mounted');
        setTimeout(function () { root.classList.remove('is-mounted'); }, 900);
      });

      if (!cacheHit) schedulePreload();
    }
    function findRootIn(node) {
      if (!node) return null;
      if (node.matches && node.matches('[data-eds-drive]')) return node;
      if (node.querySelector) return node.querySelector('[data-eds-drive]');
      return null;
    }

    function autoInit() {
      var roots = document.querySelectorAll('[data-eds-drive]');
      for (var i = 0; i < roots.length; i += 1) initSection(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoInit, { once: true });
    } else {
      autoInit();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = findRootIn(e.target);
      if (root) initSection(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = findRootIn(e.target);
      if (root && root.__edsDrive && typeof root.__edsDrive.destroy === 'function') {
        root.__edsDrive.destroy();
      }
    });

    document.addEventListener('shopify:section:reorder', function (e) {
      var root = findRootIn(e.target);
      if (root && root.__edsDrive) {
        root.__edsDrive.destroy();
        initSection(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eds-mini-drive-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* ============================================================
       Constants and pre-compiled helpers
       ============================================================ */

    var DISPLAY_FIXES = {
      'Break Transistor': 'Brake Transistor',
      'Dynamic Breaking': 'Dynamic Braking',
      'High Performace': 'High Performance',
      'Built-In DC Choke See -te-7': 'Built-In DC Choke'
    };

    var FIXES_RE = (function () {
      var keys = Object.keys(DISPLAY_FIXES).map(function (k) {
        return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      });
      return new RegExp(keys.join('|'), 'g');
    })();

    var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    var ESCAPE_RE = /[&<>"']/g;

    var STAGGER_CAP = 12;

    // <!-- ---> Fields Omar flagged Hidden on mobile. Kept in the DOM,
    // dropped by CSS so desktop still shows them. <!-- --->
    var MOBILE_HIDDEN = {
      output_voltage: 1,
      approvals: 1,
      built_in_protection: 1,
      special_feature: 1,
      fieldbus: 1
    };

    function escapeHTML(s) {
      return String(s).replace(ESCAPE_RE, function (ch) { return ESCAPE_MAP[ch]; });
    }

    function toText(v) {
      if (v === null || v === undefined) return '';
      if (Array.isArray(v)) {
        return v.map(toText).filter(Boolean).join(', ');
      }
      if (typeof v === 'object') {
        if (v.value !== undefined) return toText(v.value);
        if (v.name !== undefined) return toText(v.name);
        return '';
      }
      return String(v).trim();
    }

    function fixText(v) {
      var t = toText(v);
      if (!t) return '';
      if (DISPLAY_FIXES[t]) return DISPLAY_FIXES[t];
      return t.replace(FIXES_RE, function (m) { return DISPLAY_FIXES[m]; });
    }

    function normalize(v) {
      return toText(v).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    // <!-- ---> Natural, numeric-aware alphabetical sort. Orders "2 HP"
    // before "10 HP" and "230" before "480" while staying alphabetical
    // per Omar's spec. Used for both filter dropdowns and column sort. <!-- --->
    function alphaCompare(a, b) {
      return String(a || '').localeCompare(String(b || ''), undefined, { numeric: true, sensitivity: 'base' });
    }

    function parseJSON(node) {
      if (!node) return null;
      try { return JSON.parse(node.textContent || '{}'); }
      catch (e) { return null; }
    }

    function rIC(fn) {
      if (typeof window.requestIdleCallback === 'function') {
        return window.requestIdleCallback(fn, { timeout: 1500 });
      }
      return window.setTimeout(fn, 80);
    }

    function cIC(handle) {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(handle);
      } else {
        window.clearTimeout(handle);
      }
    }

    /* ============================================================
       Preprocessing: every product computed once and cached
       ============================================================ */

    function preprocessProduct(raw, empty) {
      var brand = fixText(raw.brand);
      var hp = fixText(raw.motor_power_hp);
      var amps = fixText(raw.output_current_amps);
      var iv = fixText(raw.input_voltage);
      var ov = fixText(raw.output_voltage);
      var enc = fixText(raw.enclosure_rating);
      var sku = fixText(raw.sku);
      var appr = fixText(raw.approvals);
      var prot = fixText(raw.built_in_protection);
      var feat = fixText(raw.special_feature);
      var bus = fixText(raw.fieldbus);
      var emc = fixText(raw.emc_filter);

      return {
        raw: raw,
        key: toText(raw.id) || toText(raw.handle) || sku,
        url: toText(raw.url),
        brandRaw: brand,
        skuRaw: sku,
        datasheet: toText(raw.datasheet),
        variantId: raw.variant_id ? String(raw.variant_id) : '',
        available: raw.available !== false,
        ariaEsc: escapeHTML(sku || toText(raw.title) || 'drive'),
        text: {
          brand: brand,
          motor_power_hp: hp,
          output_current_amps: amps,
          input_voltage: iv,
          output_voltage: ov,
          enclosure_rating: enc,
          model_number: sku
        },
        display: {
          brand: escapeHTML(brand || empty),
          motor_power_hp: escapeHTML(hp || empty),
          output_current_amps: escapeHTML(amps || empty),
          input_voltage: escapeHTML(iv || empty),
          output_voltage: escapeHTML(ov || empty),
          enclosure_rating: escapeHTML(enc || empty),
          model_number: escapeHTML(sku || empty),
          approvals: escapeHTML(appr || empty),
          built_in_protection: escapeHTML(prot || empty),
          special_feature: escapeHTML(feat || empty),
          fieldbus: escapeHTML(bus || empty)
        },
        original: {
          motor_power_hp: hp,
          input_voltage: iv,
          enclosure_rating: enc,
          emc_filter: emc
        },
        filter: {
          motor_power_hp: normalize(hp),
          input_voltage: normalize(iv),
          enclosure_rating: normalize(enc),
          emc_filter: normalize(emc)
        }
      };
    }

    /* ============================================================
       Cell construction
       ============================================================ */

    function cell(field, content, labels) {
      var hidden = MOBILE_HIDDEN[field] ? ' data-mobile-hidden="true"' : '';
      return '<td data-field="' + field + '" data-label="' + escapeHTML(labels[field] || field) + '"' + hidden + '>' + content + '</td>';
    }

    function buildRowCellsHTML(p, icons, labels, options, brandColor) {
      var d = p.display;
      var aria = p.ariaEsc;

      // <!-- ---> Brand. Plain text per spec; optional chip when brand_style
      // is set to chip and the vendor matches a Brand block. <!-- --->
      var brandInner;
      if (options.brandStyle === 'chip' && p.brandRaw) {
        var chipStyle = brandColor ? ' style="--eds-mds-brand-color: ' + escapeHTML(brandColor) + '"' : '';
        brandInner = '<span class="eds-mds__chip"' + chipStyle + '>' + d.brand + '</span>';
      } else {
        brandInner = '<span class="eds-mds__brand">' + d.brand + '</span>';
      }
      var brandCell = '<td data-field="brand" data-label="' + escapeHTML(labels.brand || 'Brand') + '">' + brandInner + '</td>';

      // <!-- ---> Model Number. Variant SKU linked to the product page. <!-- --->
      var modelLabel = escapeHTML(labels.model_number || 'Model Number');
      var modelInner;
      if (p.url && p.skuRaw) {
        modelInner =
          '<span class="eds-mds__model-label">' + modelLabel + '</span>' +
          '<a class="eds-mds__model-link" href="' + escapeHTML(p.url) + '">' + escapeHTML(p.skuRaw) + '</a>';
      } else {
        modelInner =
          '<span class="eds-mds__model-label">' + modelLabel + '</span>' +
          '<span class="eds-mds__model">' + d.model_number + '</span>';
      }
      var modelCell = '<td data-field="model_number" data-label="' + modelLabel + '">' + modelInner + '</td>';

      // <!-- ---> Datasheet. Icon link, or disabled icon when no URL. <!-- --->
      var dsCell = '';
      if (options.showDatasheet) {
        var dsInner;
        if (p.datasheet) {
          dsInner =
            '<a class="eds-mds__action eds-mds__action--ds" href="' + escapeHTML(p.datasheet) +
            '" target="_blank" rel="noopener" aria-label="Open data sheet for ' + aria + '">' +
            icons.datasheet + '</a>';
        } else {
          dsInner =
            '<span class="eds-mds__action eds-mds__action--ds is-disabled" aria-disabled="true"' +
            ' aria-label="No data sheet available">' + icons.datasheet + '</span>';
        }
        dsCell =
          '<td data-field="datasheet" data-label="' + escapeHTML(labels.datasheet || 'DS') +
          '" data-align="center"><div class="eds-mds__actions">' + dsInner + '</div></td>';
      }

      // <!-- ---> Add to cart. Posts the first available variant to
      // /cart/add.js. Disabled when the variant is unavailable. <!-- --->
      var cartCell = '';
      if (options.showCart) {
        var cartInner;
        if (p.variantId && p.available) {
          cartInner =
            '<button type="button" class="eds-mds__action eds-mds__action--cart"' +
            ' data-add-to-cart data-variant-id="' + escapeHTML(p.variantId) +
            '" aria-label="Add ' + aria + ' to cart">' +
            icons.cart +
            '<span class="eds-mds__action-label" data-cart-label>' + escapeHTML(options.cartLabel) + '</span>' +
            '</button>';
        } else {
          cartInner =
            '<button type="button" class="eds-mds__action eds-mds__action--cart is-soldout" disabled' +
            ' aria-label="' + escapeHTML(options.cartSoldOutLabel) + '">' +
            '<span class="eds-mds__action-label">' + escapeHTML(options.cartSoldOutLabel) + '</span>' +
            '</button>';
        }
        cartCell =
          '<td data-field="cart" data-label="' + escapeHTML(labels.cart || 'Cart') +
          '" data-align="center"><div class="eds-mds__actions">' + cartInner + '</div></td>';
      }

      var mobileToggleCell =
        '<td class="eds-mds__mobile-toggle-cell" data-field="mobile_toggle" data-label="Details">' +
          '<button type="button" class="eds-mds__mobile-toggle" data-mobile-toggle aria-expanded="false">' +
            '<span data-mobile-toggle-text></span>' +
            '<span class="eds-mds__mobile-toggle-icon" aria-hidden="true"></span>' +
          '</button>' +
        '</td>';

      return (
        brandCell +
        cell('motor_power_hp', d.motor_power_hp, labels) +
        cell('output_current_amps', d.output_current_amps, labels) +
        cell('input_voltage', d.input_voltage, labels) +
        (options.showOutputVoltage ? cell('output_voltage', d.output_voltage, labels) : '') +
        cell('enclosure_rating', d.enclosure_rating, labels) +
        modelCell +
        (options.showApprovals ? cell('approvals', d.approvals, labels) : '') +
        (options.showBuiltInProtection ? cell('built_in_protection', d.built_in_protection, labels) : '') +
        (options.showSpecialFeature ? cell('special_feature', d.special_feature, labels) : '') +
        (options.showFieldbus ? cell('fieldbus', d.fieldbus, labels) : '') +
        dsCell +
        cartCell +
        mobileToggleCell
      );
    }

    /* ============================================================
       Sort (natural alphabetical, empties last)
       ============================================================ */

    function sortCompare(key, a, b) {
      var av = a.text[key] || '';
      var bv = b.text[key] || '';
      if (!av && !bv) return 0;
      if (!av) return 1;
      if (!bv) return -1;
      return alphaCompare(av, bv);
    }

    /* ============================================================
       Section initialization
       ============================================================ */

    function initSection(root) {
      if (root.__edsMds) return;

      var configNode = root.querySelector('[data-eds-mds-config]');
      var dataNode = root.querySelector('[data-eds-mds-data]');
      var tbody = root.querySelector('[data-tbody]');
      var table = root.querySelector('[data-table]');
      var resetBtn = root.querySelector('[data-reset]');
      var capEl = root.querySelector('[data-cap]');
      var iconTemplate = root.querySelector('[data-eds-mds-icon]');

      if (!tbody || !table || !configNode || !dataNode) return;

      var MAX_ROWS = parseInt(root.getAttribute('data-max-rows'), 10) || 150;
      if (MAX_ROWS < 50) MAX_ROWS = 50;

      var config = parseJSON(configNode);
      var initialData = parseJSON(dataNode);
      if (!config || !initialData) return;

      var EMPTY = config.emptyValue || '–';
      var SHOW_COUNTS = config.showCounts === true;
      var PLACEHOLDER = config.placeholder || 'Any';
      var MOBILE_MORE = config.mobileMoreLabel || 'View More';
      var MOBILE_LESS = config.mobileLessLabel || 'View Less';
      var EMPTY_TITLE = config.emptyTitle || 'No drives match';
      var EMPTY_MSG = config.emptyMessage || 'Try widening your filters.';
      var LABELS = config.columnLabels || {};
      var CACHE_KEY = 'eds-mds:' + (root.dataset.sectionId || '') + ':' + (root.dataset.cacheKey || 'v1');

      // <!-- ---> Brand color map from blocks, matched case-insensitively
      // against product.vendor. Drives the optional chip and row stripe. <!-- --->
      var brandColorMap = Object.create(null);
      var brands = Array.isArray(config.brands) ? config.brands : [];
      for (var bi = 0; bi < brands.length; bi += 1) {
        var bdef = brands[bi];
        if (bdef && bdef.name) brandColorMap[String(bdef.name).toLowerCase()] = bdef.color || '';
      }

      function colorForBrand(name) {
        if (!name) return '';
        return brandColorMap[String(name).toLowerCase()] || '';
      }

      var SHOW_STRIPE = config.showBrandStripe === true;

      // <!-- ---> Brand priority for the default round-robin order, taken from
      // the Brand blocks in their configured order. Normalized to match the
      // vendor values. <!-- --->
      var brandOrder = [];
      for (var bo = 0; bo < brands.length; bo += 1) {
        if (brands[bo] && brands[bo].name) {
          var bnorm = normalize(brands[bo].name);
          if (bnorm && brandOrder.indexOf(bnorm) === -1) brandOrder.push(bnorm);
        }
      }
      var BALANCE_BRANDS = config.balanceBrands !== false;

      var CART_LABEL = config.cartLabel || 'Add';
      var CART_ADDING = config.cartAddingLabel || 'Adding';
      var CART_ADDED = config.cartAddedLabel || 'Added';
      var CART_SOLD_OUT = config.cartSoldOutLabel || 'Sold out';
      var CART_ERROR = config.cartErrorLabel || 'Try again';
      var CART_REDIRECT = config.cartRedirect === true;

      var actionOptions = {
        brandStyle: config.brandStyle === 'chip' ? 'chip' : 'plain',
        showDatasheet: config.showDatasheet !== false,
        showCart: config.showCart === true,
        cartLabel: CART_LABEL,
        cartSoldOutLabel: CART_SOLD_OUT,
        showOutputVoltage: config.showOutputVoltage !== false,
        showApprovals: config.showApprovals !== false,
        showBuiltInProtection: config.showBuiltInProtection !== false,
        showSpecialFeature: config.showSpecialFeature !== false,
        showFieldbus: config.showFieldbus !== false
      };

      var emptyColspan = 6
        + (actionOptions.showOutputVoltage ? 1 : 0)
        + (actionOptions.showApprovals ? 1 : 0)
        + (actionOptions.showBuiltInProtection ? 1 : 0)
        + (actionOptions.showSpecialFeature ? 1 : 0)
        + (actionOptions.showFieldbus ? 1 : 0)
        + (actionOptions.showDatasheet ? 1 : 0)
        + (actionOptions.showCart ? 1 : 0);

      var filterSelects = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var sortButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sort]'));
      var visibleFilters = filterSelects.map(function (s) { return s.dataset.filter; });
      var FILTER_KEYS = visibleFilters.slice();

      // <!-- ---> Locked filters: force-applied to every match, never shown as
      // a dropdown. These are the industry scope (e.g. Mining locks Enclosure
      // to NEMA 4). Held fixed in matching and in option counting. <!-- --->
      var LOCK_KEYS = [];
      var lockNorm = Object.create(null);
      var lockedCfg = config.lockedFilters || {};
      for (var lk in lockedCfg) {
        if (Object.prototype.hasOwnProperty.call(lockedCfg, lk)) {
          LOCK_KEYS.push(lk);
          lockNorm[lk] = normalize(lockedCfg[lk]);
        }
      }

      // <!-- ---> Default filters: visible dropdowns that start pre-selected.
      // Reset returns each one here rather than to Any. <!-- --->
      var DEFAULTS = Object.create(null);
      var defCfg = config.defaultFilters || {};
      for (var dk in defCfg) {
        if (Object.prototype.hasOwnProperty.call(defCfg, dk)) {
          DEFAULTS[dk] = defCfg[dk];
        }
      }

      var state = {};
      var stateNorm = {};
      FILTER_KEYS.forEach(function (k) {
        var def = DEFAULTS[k] || '';
        state[k] = def;
        stateNorm[k] = normalize(def);
      });

      var sortState = { key: '', dir: 'asc' };
      var products = [];
      var totalPages = (initialData.pagination && initialData.pagination.pages) ? Number(initialData.pagination.pages) : 1;
      var currentPage = (initialData.pagination && initialData.pagination.current_page) ? Number(initialData.pagination.current_page) : 1;
      var uniqueCache = Object.create(null);
      var icons = {
        datasheet: iconTemplate ? iconTemplate.innerHTML : '',
        cart: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.2a1.5 1.5 0 0 0 1.5-1.2L21.5 8H6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<circle cx="10" cy="20.5" r="1.4" fill="currentColor"/>' +
          '<circle cx="18" cy="20.5" r="1.4" fill="currentColor"/></svg>'
      };

      var cleanup = [];
      var abortController = null;
      var idleHandle = null;
      var observer = null;
      var preloadStarted = false;
      var preloadComplete = false;

      // <!-- ---> Progressive paint: first slice renders synchronously for an
      // instant first frame, the remainder streams in rAF-driven chunks. A
      // token cancels any in-flight paint when a new render supersedes it. <!-- --->
      var renderToken = 0;
      var FIRST_PAINT = 40;
      var PAINT_CHUNK = 90;
      var rafHandle = null;

      /* -------- Caching -------- */

      // <!-- ---> Payload shape version. Bump whenever the product object
      // gains or loses fields so a stale cache can never strand a column. <!-- --->
      var PAYLOAD_V = 1;

      function loadFromCache() {
        try {
          var stored = sessionStorage.getItem(CACHE_KEY);
          if (!stored) return false;
          var parsed = JSON.parse(stored);
          if (!parsed || parsed.v !== PAYLOAD_V || !Array.isArray(parsed.raw)) return false;
          if (parsed.raw.length < (initialData.products || []).length) return false;
          // <!-- ---> Reject if the shape is missing fields this render needs. <!-- --->
          if (actionOptions.showCart && parsed.raw.length && !('variant_id' in parsed.raw[0])) return false;
          ingest(parsed.raw);
          preloadComplete = true;
          return true;
        } catch (e) { return false; }
      }

      function saveToCache() {
        try {
          var raw = products.map(function (p) { return p.raw; });
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ v: PAYLOAD_V, raw: raw }));
        } catch (e) {}
      }

      function ingest(rawList) {
        var seen = Object.create(null);
        var out = [];
        for (var i = 0; i < rawList.length; i += 1) {
          var raw = rawList[i];
          var k = toText(raw.id) || toText(raw.handle) || toText(raw.sku);
          if (!k || seen[k]) continue;
          seen[k] = true;
          out.push(preprocessProduct(raw, EMPTY));
        }
        products = out;
        uniqueCache = Object.create(null);
      }

      function mergeRaw(more) {
        if (!more || !more.length) return;
        var byKey = Object.create(null);
        for (var i = 0; i < products.length; i += 1) byKey[products[i].key] = true;
        var fresh = [];
        for (var j = 0; j < more.length; j += 1) {
          var raw = more[j];
          var k = toText(raw.id) || toText(raw.handle) || toText(raw.sku);
          if (!k || byKey[k]) continue;
          byKey[k] = true;
          fresh.push(preprocessProduct(raw, EMPTY));
        }
        if (fresh.length) {
          products = products.concat(fresh);
          uniqueCache = Object.create(null);
        }
      }

      /* -------- Filter matching -------- */

      // <!-- ---> Locked filters are applied first and always, then the
      // visitor's visible filter picks. <!-- --->
      function matches(p) {
        var pf = p.filter;
        for (var l = 0; l < LOCK_KEYS.length; l += 1) {
          var lkey = LOCK_KEYS[l];
          if (pf[lkey] !== lockNorm[lkey]) return false;
        }
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          var key = FILTER_KEYS[i];
          var want = stateNorm[key];
          if (!want) continue;
          if (pf[key] !== want) return false;
        }
        return true;
      }

      // <!-- ---> Compatible options for a visible filter, holding the other
      // visible filters and every locked filter fixed. <!-- --->
      function uniqueValues(filterKey) {
        var sigParts = [];
        for (var i = 0; i < FILTER_KEYS.length; i += 1) {
          sigParts.push(FILTER_KEYS[i] === filterKey ? '' : stateNorm[FILTER_KEYS[i]]);
        }
        var sig = filterKey + '|' + sigParts.join('|');
        if (uniqueCache[sig]) return uniqueCache[sig];

        var counts = Object.create(null);
        for (var j = 0; j < products.length; j += 1) {
          var p = products[j];
          var ok = true;
          for (var l = 0; l < LOCK_KEYS.length; l += 1) {
            var lkey = LOCK_KEYS[l];
            if (p.filter[lkey] !== lockNorm[lkey]) { ok = false; break; }
          }
          if (!ok) continue;
          for (var x = 0; x < FILTER_KEYS.length; x += 1) {
            var k = FILTER_KEYS[x];
            if (k === filterKey) continue;
            var want = stateNorm[k];
            if (want && p.filter[k] !== want) { ok = false; break; }
          }
          if (!ok) continue;
          var val = p.original[filterKey];
          if (!val) continue;
          counts[val] = (counts[val] || 0) + 1;
        }
        uniqueCache[sig] = counts;
        return counts;
      }

      /* -------- Dropdowns -------- */

      // <!-- ---> userDriven gates the cascading auto-preselect. It is true only
      // when the visitor changed a filter, so the cascade keeps narrowing toward
      // one drive. On initial load, Reset, and preload it is false, so no filter
      // is silently pre-picked beyond the configured defaults, and Reset always
      // restores the configured starting point. <!-- --->
      function repopulateSelect(filterKey, userDriven) {
        var select = root.querySelector('[data-filter="' + filterKey + '"]');
        if (!select) return;

        var counts = uniqueValues(filterKey);
        var keys = Object.keys(counts).sort(alphaCompare);
        var current = state[filterKey];

        if (current && !counts[current]) {
          current = '';
          state[filterKey] = '';
          stateNorm[filterKey] = '';
        }

        // <!-- ---> Cascading auto-preselect: only on a user-driven change, and
        // only when exactly one compatible option remains and nothing is picked.
        // Never fires on load, Reset, or preload. <!-- --->
        if (userDriven && !current && keys.length === 1) {
          current = keys[0];
          state[filterKey] = current;
          stateNorm[filterKey] = normalize(current);
        }

        var html = '<option value="">' + escapeHTML(PLACEHOLDER) + '</option>';
        for (var i = 0; i < keys.length; i += 1) {
          var key = keys[i];
          var label = fixText(key) || EMPTY;
          var selected = key === current ? ' selected' : '';
          var text = SHOW_COUNTS ? label + ' (' + counts[key] + ')' : label;
          html += '<option value="' + escapeHTML(key) + '"' + selected + '>' + escapeHTML(text) + '</option>';
        }

        select.innerHTML = html;
        select.value = current;
        select.disabled = !keys.length && !current;
        syncFilterActive(filterKey);
      }

      function repopulateSelects(userDriven) {
        for (var i = 0; i < visibleFilters.length; i += 1) repopulateSelect(visibleFilters[i], userDriven);
      }

      function syncFilterActive(filterKey) {
        var wrap = root.querySelector('[data-filter-wrap="' + filterKey + '"]');
        if (!wrap) return;
        wrap.classList.toggle('is-active', Boolean(state[filterKey]));
      }

      // <!-- ---> Reset is enabled only when a visible filter differs from its
      // configured default, so a fully defaulted page starts with Reset off. <!-- --->
      function syncReset() {
        if (!resetBtn) return;
        var changed = false;
        for (var i = 0; i < visibleFilters.length; i += 1) {
          var k = visibleFilters[i];
          var def = DEFAULTS[k] || '';
          if (normalize(state[k]) !== normalize(def)) { changed = true; break; }
        }
        resetBtn.disabled = !changed;
      }

      function syncSortButtons() {
        for (var i = 0; i < sortButtons.length; i += 1) {
          var b = sortButtons[i];
          if (b.dataset.sort === sortState.key) {
            b.setAttribute('aria-sort', sortState.dir === 'desc' ? 'descending' : 'ascending');
          } else {
            b.setAttribute('aria-sort', 'none');
          }
        }
      }

      /* -------- Rendering -------- */

      // <!-- ---> Round-robin the matched rows across the brand buckets in
      // configured order, so the first slice (and the row cap) always covers
      // every brand present. Unknown vendors append after the known brands in
      // first-seen order. <!-- --->
      function interleaveByBrand(rows) {
        if (rows.length < 2 || !brandOrder.length) return rows;
        var buckets = Object.create(null);
        var order = [];
        for (var i = 0; i < brandOrder.length; i += 1) {
          var seed = brandOrder[i];
          if (!(seed in buckets)) { buckets[seed] = []; order.push(seed); }
        }
        for (var r = 0; r < rows.length; r += 1) {
          var n = normalize(rows[r].brandRaw);
          if (!(n in buckets)) { buckets[n] = []; order.push(n); }
          buckets[n].push(rows[r]);
        }
        var out = [];
        var ptr = Object.create(null);
        for (var o = 0; o < order.length; o += 1) ptr[order[o]] = 0;
        while (out.length < rows.length) {
          var advanced = false;
          for (var k = 0; k < order.length; k += 1) {
            var key = order[k];
            var arr = buckets[key];
            if (ptr[key] < arr.length) {
              out.push(arr[ptr[key]]);
              ptr[key] += 1;
              advanced = true;
            }
          }
          if (!advanced) break;
        }
        return out;
      }

      function filteredRows() {
        var rows = [];
        for (var i = 0; i < products.length; i += 1) {
          if (matches(products[i])) rows.push(products[i]);
        }
        if (sortState.key) {
          var key = sortState.key;
          var dir = sortState.dir === 'desc' ? -1 : 1;
          rows.sort(function (a, b) { return sortCompare(key, a, b) * dir; });
        } else if (BALANCE_BRANDS) {
          rows = interleaveByBrand(rows);
        }
        return rows;
      }

      function renderResults() {
        var rows = filteredRows();
        var totalMatched = rows.length;

        // <!-- ---> Cap rendered DOM at the configured max. Products beyond
        // the cap stay in memory and feed filter/sort logic, but never paint
        // until the user filters into them. <!-- --->
        var capped = false;
        if (rows.length > MAX_ROWS) {
          rows = rows.slice(0, MAX_ROWS);
          capped = true;
        }

        if (capEl) {
          if (capped) {
            capEl.textContent = 'Showing ' + MAX_ROWS + ' of ' + totalMatched + ' drives. Use filters or sort to find specific drives.';
            capEl.hidden = false;
          } else if (totalMatched > 0) {
            capEl.hidden = true;
          }
        }

        if (!rows.length) {
          tbody.innerHTML =
            '<tr class="eds-mds__empty-row">' +
              '<td class="eds-mds__empty-cell" colspan="' + emptyColspan + '">' +
                '<div class="eds-mds__empty">' +
                  '<div class="eds-mds__empty-title">' + escapeHTML(EMPTY_TITLE) + '</div>' +
                  '<p>' + escapeHTML(EMPTY_MSG) + '</p>' +
                '</div>' +
              '</td>' +
            '</tr>';
          return;
        }

        // <!-- ---> Build cell HTML (cached per product) for every matched
        // row, then paint the first slice now and stream the rest. <!-- --->
        var html = new Array(rows.length);
        for (var i = 0; i < rows.length; i += 1) {
          var p = rows[i];
          var idx = i < STAGGER_CAP ? i : STAGGER_CAP;
          var brandColor = SHOW_STRIPE || actionOptions.brandStyle === 'chip' ? colorForBrand(p.brandRaw) : '';

          if (actionOptions.brandStyle === 'chip') {
            if (p._cellsHTMLForColor !== brandColor || !p._cellsHTML) {
              p._cellsHTML = buildRowCellsHTML(p, icons, LABELS, actionOptions, brandColor);
              p._cellsHTMLForColor = brandColor;
            }
          } else if (!p._cellsHTML) {
            p._cellsHTML = buildRowCellsHTML(p, icons, LABELS, actionOptions, '');
          }

          var stripeColor = SHOW_STRIPE ? brandColor : '';
          var rowStyle = '--row-i:' + idx;
          if (stripeColor) rowStyle += ';--eds-mds-brand-color:' + stripeColor;
          var rowClass = stripeColor ? ' class="has-brand-color"' : '';

          html[i] = '<tr' + rowClass + ' style="' + rowStyle + '" data-mobile-row data-mobile-expanded="false">' +
            p._cellsHTML + '</tr>';
        }

        renderToken += 1;
        var token = renderToken;
        if (rafHandle) { cancelAnimationFrame(rafHandle); rafHandle = null; }

        var firstCount = Math.min(FIRST_PAINT, html.length);
        tbody.innerHTML = html.slice(0, firstCount).join('');
        labelToggles(tbody);

        if (firstCount < html.length) {
          var cursor = firstCount;
          var step = function () {
            if (token !== renderToken) return;
            var next = Math.min(cursor + PAINT_CHUNK, html.length);
            var frag = html.slice(cursor, next).join('');
            tbody.insertAdjacentHTML('beforeend', frag);
            labelToggles(tbody);
            cursor = next;
            if (cursor < html.length) {
              rafHandle = requestAnimationFrame(step);
            } else {
              rafHandle = null;
            }
          };
          rafHandle = requestAnimationFrame(step);
        }
      }

      function labelToggles(scope) {
        var toggles = scope.querySelectorAll('[data-mobile-toggle-text]:empty');
        for (var t = 0; t < toggles.length; t += 1) toggles[t].textContent = MOBILE_MORE;
      }

      // <!-- ---> userDriven flows through to the dropdown rebuild so the
      // cascade only auto-preselects on real filter changes. <!-- --->
      function refresh(userDriven) {
        repopulateSelects(userDriven);
        renderResults();
        syncReset();
        syncSortButtons();
      }

      /* -------- Events -------- */

      function on(el, evt, fn, opts) {
        if (!el) return;
        el.addEventListener(evt, fn, opts || false);
        cleanup.push(function () { el.removeEventListener(evt, fn, opts || false); });
      }

      function onFilterChange(e) {
        var select = e.currentTarget;
        var key = select.dataset.filter;
        state[key] = select.value || '';
        stateNorm[key] = normalize(select.value || '');
        // <!-- ---> User-driven: allow the cascade to auto-preselect. <!-- --->
        refresh(true);
      }

      // <!-- ---> Reset restores each visible filter to its configured default
      // (Any when no default is set). Locked filters are untouched. <!-- --->
      function resetFilters() {
        for (var i = 0; i < visibleFilters.length; i += 1) {
          var k = visibleFilters[i];
          var def = DEFAULTS[k] || '';
          state[k] = def;
          stateNorm[k] = normalize(def);
          syncFilterActive(k);
        }
        refresh(false);
      }

      function onSortClick(e) {
        var b = e.currentTarget;
        var key = b.dataset.sort;
        if (!key) return;
        if (sortState.key === key) {
          sortState.dir = sortState.dir === 'asc' ? 'desc' : 'asc';
        } else {
          sortState.key = key;
          sortState.dir = 'asc';
        }
        renderResults();
        syncSortButtons();
      }

      function onTbodyClick(e) {
        if (!e.target.closest) return;

        var cartBtn = e.target.closest('[data-add-to-cart]');
        if (cartBtn) {
          addToCart(cartBtn);
          return;
        }

        var toggle = e.target.closest('[data-mobile-toggle]');
        if (!toggle) return;
        var row = toggle.closest('[data-mobile-row]');
        if (!row) return;
        var expanded = row.getAttribute('data-mobile-expanded') === 'true';
        var next = !expanded;
        row.setAttribute('data-mobile-expanded', next ? 'true' : 'false');
        row.classList.toggle('is-mobile-expanded', next);
        toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
        var txt = toggle.querySelector('[data-mobile-toggle-text]');
        if (txt) txt.textContent = next ? MOBILE_LESS : MOBILE_MORE;
      }

      /* -------- Add to cart -------- */

      function setCartLabel(btn, text) {
        var label = btn.querySelector('[data-cart-label]');
        if (label) label.textContent = text;
      }

      function addToCart(btn) {
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || !window.fetch) return;

        if (btn.__edsResetTimer) { window.clearTimeout(btn.__edsResetTimer); btn.__edsResetTimer = null; }

        btn.setAttribute('aria-busy', 'true');
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');
        setCartLabel(btn, CART_ADDING);

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function (data) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.removeAttribute('aria-busy');
            setCartLabel(btn, CART_ADDED);

            // <!-- ---> Notify the theme so cart drawer / count can refresh.
            // Same event names as the full selector so one drawer covers both. <!-- --->
            var detail = { source: 'eds-mini-drive', items: data && data.items ? data.items : [data], variantId: variantId };
            document.dispatchEvent(new CustomEvent('eds:cart:added', { bubbles: true, detail: detail }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
            if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
              try { window.Shopify.onItemAdded(data); } catch (err) {}
            }

            if (CART_REDIRECT) {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
              return;
            }

            btn.__edsResetTimer = window.setTimeout(function () {
              btn.classList.remove('is-added');
              setCartLabel(btn, CART_LABEL);
            }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            btn.removeAttribute('aria-busy');
            setCartLabel(btn, CART_ERROR);
            btn.__edsResetTimer = window.setTimeout(function () {
              btn.classList.remove('is-error');
              setCartLabel(btn, CART_LABEL);
            }, 2200);
          });
      }

      /* -------- Preload (Section Rendering API) -------- */

      function buildPageUrl(page) {
        var url = new URL(window.location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('page', String(page));
        return url.toString();
      }

      function fetchPage(page) {
        if (!window.fetch) return Promise.resolve(null);
        var opts = { credentials: 'same-origin' };
        if (abortController) opts.signal = abortController.signal;

        return fetch(buildPageUrl(page), opts)
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-eds-mds-data]');
            return node ? parseJSON(node) : null;
          })
          .catch(function () { return null; });
      }

      function startPreload() {
        if (preloadStarted || preloadComplete || totalPages <= 1) return;
        preloadStarted = true;

        if ('AbortController' in window) abortController = new AbortController();

        var jobs = [];
        for (var page = 1; page <= totalPages; page += 1) {
          if (page !== currentPage) jobs.push(fetchPage(page));
        }

        Promise.all(jobs).then(function (payloads) {
          var more = [];
          for (var i = 0; i < payloads.length; i += 1) {
            var pl = payloads[i];
            if (pl && Array.isArray(pl.products)) more = more.concat(pl.products);
          }
          mergeRaw(more);
          saveToCache();
          preloadComplete = true;
          // <!-- ---> Preload merge is not user-driven: refresh without the
          // cascade so newly available options never auto-collapse the table. <!-- --->
          refresh(false);
        });
      }

      function schedulePreload() {
        if (preloadComplete || totalPages <= 1) return;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i += 1) {
              if (entries[i].isIntersecting) {
                if (observer) { observer.disconnect(); observer = null; }
                idleHandle = rIC(startPreload);
                break;
              }
            }
          }, { rootMargin: '400px' });
          observer.observe(root);
        } else {
          idleHandle = rIC(startPreload);
        }
      }

      /* -------- Lifecycle -------- */

      function destroy() {
        if (abortController) { try { abortController.abort(); } catch (e) {} }
        if (idleHandle) cIC(idleHandle);
        if (rafHandle) { cancelAnimationFrame(rafHandle); rafHandle = null; }
        renderToken += 1;
        if (observer) { observer.disconnect(); observer = null; }
        for (var i = 0; i < cleanup.length; i += 1) {
          try { cleanup[i](); } catch (e) {}
        }
        cleanup = [];
        delete root.__edsMds;
      }

      root.__edsMds = { destroy: destroy };

      /* -------- Bootstrap -------- */

      var cacheHit = loadFromCache();
      if (!cacheHit) ingest(initialData.products || []);

      for (var f = 0; f < filterSelects.length; f += 1) on(filterSelects[f], 'change', onFilterChange);
      for (var s = 0; s < sortButtons.length; s += 1) on(sortButtons[s], 'click', onSortClick);
      on(resetBtn, 'click', resetFilters);
      on(tbody, 'click', onTbodyClick);

      // <!-- ---> Initial paint is not user-driven, so visible filters start on
      // their configured default (Any when none) and the scoped collection
      // renders behind any locked filters. <!-- --->
      refresh(false);

      requestAnimationFrame(function () {
        root.classList.add('is-mounted');
        // <!-- ---> Strip the class after the entrance runs so filter changes,
        // sorts, and SRA hydration don't re-trigger the row stagger. <!-- --->
        setTimeout(function () { root.classList.remove('is-mounted'); }, 900);
      });

      if (!cacheHit) schedulePreload();
    }

    /* ============================================================
       Auto-init and section editor hooks
       ============================================================ */

    function findRootIn(node) {
      if (!node) return null;
      if (node.matches && node.matches('[data-eds-mds]')) return node;
      if (node.querySelector) return node.querySelector('[data-eds-mds]');
      return null;
    }

    function autoInit() {
      var roots = document.querySelectorAll('[data-eds-mds]');
      for (var i = 0; i < roots.length; i += 1) initSection(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoInit, { once: true });
    } else {
      autoInit();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = findRootIn(e.target);
      if (root) initSection(root);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = findRootIn(e.target);
      if (root && root.__edsMds && typeof root.__edsMds.destroy === 'function') {
        root.__edsMds.destroy();
      }
    });

    document.addEventListener('shopify:section:reorder', function (e) {
      var root = findRootIn(e.target);
      if (root && root.__edsMds) {
        root.__edsMds.destroy();
        initSection(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
